import type { CustomIconProps } from '../types';

const Flag = ({ width, height }: CustomIconProps) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width ?? '14'}
        height={height ?? '16'}
        viewBox="0 0 14 16"
        fill="none"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0H7.93062L9.99513 2.13333H13.6671V11.0933H7.80099L5.73648 8.96H1.28V16H0V0ZM1.28 7.68H6.279L8.34352 9.81333H12.3871V3.41333H9.45261L7.38809 1.28H1.28V7.68Z"
            fill="#414042"
        />
    </svg>
);

export default Flag;
